import Cliente from "pages/Cliente/Cliente";
import ControleAtendimento from "pages/ControleAtendimento/ControleAtendimento";
import Impressao from "pages/Impressao/Impressao";
import PainelControle from "pages/PainelControle/PainelControle";
import QrCode from "pages/QrCode/QrCode";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import ComingSoon from "../pages/Pages/ComingSoon/ComingSoon";
import Maintenance from "../pages/Pages/Maintenance/Maintenance";

const host = window.location.hostname;
let defaultComponent = <PainelControle />;
if (host == "visu.filagrupoav.com.br") {
  defaultComponent = <ControleAtendimento />;
}
if (host == "cliente.filagrupoav.com.br") {
  defaultComponent = <Cliente />;
}
if (host == "qrcode.filagrupoav.com.br") {
  defaultComponent = <QrCode />;
}
const publicRoutes = [
  { path: "/impressao", component: <Impressao /> },
  { path: "/qr-code", component: <QrCode /> },
  { path: "/painel-controle", component: <PainelControle /> },
  { path: "/controle-atendimento", component: <ControleAtendimento /> },
  { path: "/cliente", component: <Cliente /> },
  { path: "/auth-404", component: <Basic404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },
  { path: "/auth-offline", component: <Offlinepage /> },
  {
    path: "/",
    exact: true,
    component: defaultComponent,
  },
];

export { publicRoutes };

